import {Subscription} from "rxjs";

export class BaseComponent {

  constructor() {
  }

  private readonly subscriptions: Subscription[] = [];

  addToUnsubscribe(subscription: Subscription) {
    this.subscriptions.push(subscription);
  }

  unsubscribeAll(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
  }
}

